import NovalueCheck from './NoValueCheck';

export default (value, age, gender) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;
  var max = 0, min = 0;

  // F: 42-98, M: 53-128
  if (gender == '0' || gender === 'female') {
    max = 98;
    min = 42;
  } else {
    max = 128;
    min = 53;
  }

  if(value > max) {
    return {
      title: 'การทำงานของตับผิดปกติ',
      color: 'red',
      caption: 'ค่า ALP สูงกว่าปกติ',
      suggest: 'ปรับพฤติกรรม พบนักโภชนาการ หรือ นักกำหนดอาหาร'
    };
  } else if(value < min) {
    return {
      title: 'การทำงานของตับผิดปกติ',
      color: 'red',
      caption: 'ค่า ALP ต่ำกว่าปกติ',
      suggest: 'ปรับพฤติกรรม พบนักโภชนาการ หรือ นักกำหนดอาหาร'
    };
  } else {
    return {
      title: 'การทำงานของตับปกติ',
      color: 'green',
      caption: 'การทำงานของตับปกติ',
      suggest: ''
    };
  }
}
